"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTest = void 0;
const tslib_1 = require("tslib");
require("../../../../TdWebtoolkitControls/controls/Thumbnails/Thumbnails");
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
const _ = require("underscore");
let markup = require("./thumbnails_tests.tmpl.htm");
require("./thumbnails_tests.tmpl.less");
const destroyThumbnails = ($thumbnails) => {
    if ($thumbnails.synThumbnails("isInitialized"))
        $thumbnails.synThumbnails("destroy");
};
const createThumbnailsAsync = ($thumbnails) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    destroyThumbnails($thumbnails);
    const $pane = $("#testContentPane");
    const docIdNumeric = $pane.find("#textBox_parentDocId").data("kendoNumericTextBox");
    const parentInst = yield Utilities_1.synUtil.getInstanceAsync(docIdNumeric.value().toString());
    const sizeNumeric = $("#numeric_thumbnailSize").data("kendoNumericTextBox");
    const $checkedClickBehavior = $pane.find(".clickBehaviorRadio:checked");
    const $checkedRemoveType = $pane.find(".removeTypeRadio:checked");
    const $showDownloadCheckbox = $pane.find(".showDownloadCheckbox");
    const $enableUploadCheckbox = $pane.find(".enableUploadCheckbox");
    const $allowDropCheckBox = $pane.find(".allowDropCheckBox");
    const uploadOptions = {
        categoryId: 4000,
        parentId: parentInst.id.valueAsString,
        allowDrop: $allowDropCheckBox.prop("checked") === true
    };
    $thumbnails
        .off("endFetchThumbnailInstances").on("endFetchThumbnailInstances", (e, ids) => {
        Utilities_1.synUtil.Notifications.info("[thumbnails] endFetchThumbnailInstances: " + ids.length + " thumbnails fetched.");
    })
        .synThumbnails({
        clickBehavior: $checkedClickBehavior.attr("value"),
        getThumbnailInstances: {
            parentId: parentInst.id.valueAsString
        },
        remove: $checkedRemoveType.attr("value") === "Disabled" ? false : $checkedRemoveType.attr("value"),
        showDownloadButton: $showDownloadCheckbox.prop("checked") === true,
        size: sizeNumeric.value(),
        upload: $enableUploadCheckbox.prop("checked") === true ? uploadOptions : undefined
    });
});
function renderTest() {
    $("#testContentPane").html(markup);
    const $thumbnailsDiv = $("#testContentPane").find(".thumbnailsDiv");
    $("#testContentPane").find(".createButton").on("click", () => {
        createThumbnailsAsync($thumbnailsDiv);
    });
    $("#testContentPane").find(".destroyButton").on("click", () => {
        destroyThumbnails($thumbnailsDiv);
    });
    $("#testContentPane").find(".thumbnailSizePicker").kendoNumericTextBox({
        decimals: 0,
        format: "#",
        spinners: true,
        step: 16,
        change: _.debounce((e) => {
            createThumbnailsAsync($thumbnailsDiv);
        }, 200, false)
    });
    $("#testContentPane").find(".parentDocIdTextBox").kendoNumericTextBox({
        decimals: 0,
        format: "#",
        spinners: false,
        change: (e) => {
            createThumbnailsAsync($thumbnailsDiv);
        }
    });
    $("#testContentPane").find(".enableUploadCheckbox").on("change", () => {
        createThumbnailsAsync($thumbnailsDiv);
    });
    $("#testContentPane").find(".allowDropCheckBox").on("change", () => {
        createThumbnailsAsync($thumbnailsDiv);
    });
    $("#testContentPane").find(".showDownloadCheckbox").on("change", () => {
        createThumbnailsAsync($thumbnailsDiv);
    });
    $("#testContentPane").find(".removeTypeRadio").on("change", () => {
        createThumbnailsAsync($thumbnailsDiv);
    });
    $("#testContentPane").find(".clickBehaviorRadio").on("change", () => {
        createThumbnailsAsync($thumbnailsDiv);
    });
}
exports.renderTest = renderTest;
